
import { useRequestState } from "./admin/useRequestState";
import { useRequestAuth } from "./admin/useRequestAuth";
import { useRequestData } from "./admin/useRequestData";
import { useRequestActions } from "./admin/useRequestActions";

/**
 * Main hook for admin requests page functionality
 * This hook composes other smaller hooks to provide a complete API
 * for managing group leader requests
 */
export const useAdminRequests = () => {
  // Request state (loading, data, processing)
  const {
    requests,
    setRequests,
    isLoading,
    setIsLoading,
    processingId,
    setProcessingId,
  } = useRequestState();

  // Authentication related functionality
  const { checkAuth } = useRequestAuth();

  // Data fetching functionality
  const { fetchRequests } = useRequestData(setRequests, setIsLoading);

  // Action handlers (approve, reject, delete, send invitation)
  const {
    handleApprove,
    handleReject,
    handleDelete,
    handleSendInvitation,
    handleResetPassword,
  } = useRequestActions(setProcessingId, fetchRequests);

  return {
    // State
    requests,
    isLoading,
    processingId,
    
    // Auth
    checkAuth,
    
    // Data operations
    fetchRequests,
    
    // Request actions
    handleApprove,
    handleReject,
    handleDelete,
    handleSendInvitation,
    handleResetPassword,
  };
};
